// ...new file...
import { useEffect, useRef } from 'react';

export default function useClickOutside(ref, handler, options = {}) {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  const { closeOnEscape = false } = options;

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const onPointer = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handlerRef.current(event);
    };

    const onKey = (event) => {
      if (closeOnEscape && event.key === 'Escape') {
        handlerRef.current(event);
      }
    };

    document.addEventListener('mousedown', onPointer);
    document.addEventListener('touchstart', onPointer);
    if (closeOnEscape) document.addEventListener('keydown', onKey);

    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('touchstart', onPointer);
      if (closeOnEscape) document.removeEventListener('keydown', onKey);
    };
  }, [ref, closeOnEscape]);
}
